import module from './peeps.module';
import './peeps.controller';
import './peeps.style.scss';

export default module.name;